/**
 * CR-8730: Needed For Directs and Directs Covered on a row whose supplier is
 * not a direct-delivery source. The API sends null for both — there are no
 * direct orders to count, which is not the same as needing 0 — and the Stock
 * Planning grid, its printed sheet and the Create Call-Off warehouse grid all
 * show it as an em dash.
 */

/** The two columns that are blank for a supplier that is not a direct source. */
export const DIRECTS_COLUMNS: ReadonlyArray<string> = ['needed_for_directs', 'directs_covered'];

/** What a Directs column shows when the supplier is not a direct-delivery source. */
export const NOT_A_DIRECT_SOURCE = '—';

/**
 * The text for a cell with no value.
 *
 * @param columnId - the grid column id
 * @returns an em dash for a Directs column, otherwise the grid's usual hyphen
 */
export function blankCellText(columnId: string): string {
  return DIRECTS_COLUMNS.indexOf(columnId) === -1 ? '-' : NOT_A_DIRECT_SOURCE;
}
